module.exports = __webpack_public_path__ + "static/media/play-2.0fa45fd8.svg";